<template>
  <div
      v-if="visible"
      class="fixed inset-x-0 bottom-0 z-50 border-t-2 border-brand-600 bg-white shadow-[0_-4px_20px_rgba(15,31,56,0.08)]"
  >
    <div class="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
      <div class="max-w-3xl">
        <h2 class="text-sm font-bold uppercase tracking-wider text-graphite-900">Pliki cookies</h2>
        <p class="mt-1.5 text-sm leading-relaxed text-graphite-600">
          Używamy plików cookies do analizy ruchu na stronie za pomocą Google Analytics.
          Statystyki zbieramy dopiero po Twojej zgodzie. Możesz ją odrzucić — strona będzie
          działać bez zmian.
        </p>
      </div>

      <div class="flex shrink-0 flex-col gap-3 sm:flex-row">
        <button type="button" class="btn-outline" @click="reject">
          Odrzuć
        </button>
        <button type="button" class="btn-primary" @click="accept">
          Akceptuję
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { loadAnalytics, CONSENT_KEY } from '@/utils/analytics';

export default {
  name: 'CookieConsent',
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    if (!localStorage.getItem(CONSENT_KEY)) {
      this.visible = true;
    }
  },
  methods: {
    accept() {
      localStorage.setItem(CONSENT_KEY, 'accepted');
      this.visible = false;
      loadAnalytics();
    },
    reject() {
      localStorage.setItem(CONSENT_KEY, 'rejected');
      this.visible = false;
    }
  }
};
</script>
